import { Translations } from "@types";

export const updateTranslation: (previous: Translations, languageCode: string, newValue: string) => Translations = (
    previous, languageCode, newValue
) => {
    const translationItem = previous.find(
        (item) => item.languageCode === languageCode
    );

    if (translationItem) {
        return previous.map((item) => {
            return {
                ...item,
                translation: languageCode === item.languageCode ? newValue : item.translation,
            };
        });
    } else {
        return [
            ...previous,
            { languageCode: languageCode || '', translation: newValue},
        ];
    }
};



export const getDynamicMenuItemValue = (
  settings: Record<string, unknown> | null | undefined,
  index: number
): string => {
  const keyPrefix = `content_dynamic_menu_item_${index}`;
  const value = Object.entries(settings ?? {}).find(([key]) =>
    key.startsWith(keyPrefix)
  )?.[1];

  return typeof value === "string" ? value : "";
};